import PropTypes from 'prop-types';

// material-ui
import { useTheme } from '@mui/material/styles';
import { List, Typography } from '@mui/material';

// project imports
import NavItem from '../NavItem/NavItem';
import NavCollapse from '../NavCollapse/NavCollapse';
// ==============================|| SIDEBAR MENU LIST GROUP ||============================== //

const NavGroup = ({ item, isMinimized, isMobile = false }) => {
  const theme = useTheme();

  // menu list collapse & items
  const items = item.children?.map((menu) => {
    switch (menu.type) {
      case 'collapse':
        return <NavCollapse key={menu.id} menu={menu} level={1} isMinimized={isMinimized} isMobile={isMobile} />;
      case 'item':
        return <NavItem key={menu.id} item={menu} level={1} isMinimized={isMinimized} isMobile={isMobile} />;
      default:
        return (
          <Typography key={menu.id} variant="h6" color="error" align="center">
            Menu Items Error
          </Typography>
        );
    }
  });

  return (
    <>
      <List
        className={item.title === 'FIVB NAV BAR SETTINGS' ? 'SidebarNavGroupSettings' : 'SidebarNavGroupDefault'}
        subheader={
          item.title && (
            <Typography variant="caption" sx={{ ...theme.typography.menuCaption }} display="block" gutterBottom>
              {/* {item.title} */}
              {item.caption && (
                <Typography variant="caption" display="block" gutterBottom>
                  {item.caption}
                </Typography>
              )}
            </Typography>
          )
        }
        sx={{
          ...(item.title === 'World Ranking'
            ? {
                '&:not(:last-child)': {
                  mb: isMinimized ? 'calc(100vh - 1350%)' : '2.5vw'
                }
              }
            : {})
        }}
      >
        {items}
      </List>
    </>
  );
};

NavGroup.propTypes = {
  item: PropTypes.object
};

export default NavGroup;
